import { render, staticRenderFns } from "./DialogEvent.vue?vue&type=template&id=047455ea&scoped=true&"
import script from "./DialogEvent.vue?vue&type=script&lang=js&"
export * from "./DialogEvent.vue?vue&type=script&lang=js&"
import style0 from "./DialogEvent.vue?vue&type=style&index=0&id=047455ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047455ea",
  null
  
)

export default component.exports